export default {
  currencySign: '€',
  state: "Provincia",
  city: 'Ciudad',
}